import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, PageHero } from "../components/Reveal";
import { PRINCIPLES } from "../data/site";
import useSeo from "../components/Seo";

export default function WhyUs() {
  useSeo("Why Choose Us", "Six principles define The Royal Mahaveer Roadlines — reliability, safety, timely service, flexibility, professional communication and long-term partnerships.");
  return (
    <>
      <PageHero
        overline="Why Choose Us"
        lines={[<>Six principles.</>, <>One <em className="italic text-gold-light">standard.</em></>]}
        desc="A manifesto for how we move — the commitments every consignment is carried under."
      />

      <section className="py-24 sm:py-32" data-testid="manifesto-section">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.num} delay={0.05}>
              <article
                className="group grid gap-6 border-b border-gold/15 py-12 transition-colors duration-500 sm:grid-cols-12 sm:items-baseline sm:py-16"
                data-testid={`manifesto-chapter-${p.num}`}
              >
                <div className="flex items-baseline gap-5 sm:col-span-3">
                  <span className="font-heading text-6xl leading-none text-gold/65 transition-colors duration-500 group-hover:text-gold sm:text-7xl">
                    {p.num}
                  </span>
                  <span className="hidden text-[9px] font-semibold uppercase tracking-[0.3em] text-muted-foreground/60 sm:block">
                    Principle
                  </span>
                </div>
                <div className="sm:col-span-9">
                  <h2 className="relative inline-block font-heading text-2xl tracking-[0.06em] text-foreground transition-colors duration-300 group-hover:text-gold-light sm:text-3xl">
                    {p.title}
                    <span className="absolute -bottom-2 left-0 h-px w-0 bg-gold transition-all duration-500 group-hover:w-full" />
                  </h2>
                  <p className="mt-5 max-w-xl text-sm leading-[1.85] text-muted-foreground sm:text-base">{p.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <div className="mt-20 border border-gold/20 bg-surface px-8 py-16 text-center" data-testid="whyus-closing-panel">
              <p className="overline-gold">Our Word</p>
              <p className="mx-auto mt-6 max-w-xl font-heading text-xl italic leading-relaxed text-foreground sm:text-2xl">
                “Strength in Every Journey. Reliability in Every Mile.”
              </p>
              <Link to="/quote" className="btn-solid group mt-10" data-testid="whyus-quote-cta">
                Request a Quote
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
